module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SmartHrLocalList', {
    attrs: {
      "module-type": "SAFETY",
      "title": "用工安全",
      "group-name": "员工管理"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a53380d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/smartHr/SmartHrSafety.vue
// module id = 1924
// module chunks = 8